'use strict';

define(['./../util', '../../../../lib/domQ', './../Constant', './../analytics', './CountryLinks', './../stickyHeader'], function (util, domQ, Constant, analytics, countryLinkDropDown, stickyHeader) {
    var IS_ACTIVE = 'navigation-is-active';
    var IS_SELECTED = 'is-selected';
    var PREVENT_SCROLLING = 'navigation-prevent-scrolling';
    var PREVENT_STICKYSCROLLING = 'navigation-prevent-stickyscrolling';
    var STICKY_CLASS = 'navigation-sticky';
    var ANIMATION_TRANSITION = 'transform .1s cubic-bezier(0, 0.3, 0.2, 1.02) 0s';
    var L1_ANIMATION_TRANSITION = 'transform .1s cubic-bezier(0, 0.3, 0.2, 1.02) 0s';
    var HAMBURGER_CLASS = 'navigation-res-nav-header__item--menu';
    var TOUCH_START = 'touchstart';
    var PRIMARY_SECTION_WIDTH = 0.9;
    var L3_MAXHEIGHT = '1000px';

    function XSmallDevice(level2) {
        this.level2 = level2;
        this.navPrimarySectionEl = document.querySelector('.navigation-primary__section');
        this.menuLastItem = document.querySelector('.navigation-menulastitem');
        this.navigationOverlayEl = document.getElementById('navigationOverlay');
        this.navContainerEl = document.getElementById('navContainer');
        this.hamburgerEl = document.querySelector('.' + HAMBURGER_CLASS);
        this.backLabelEl = document.querySelector('.navigation-submenu__back-bar-label');
        this.backButtonEl = document.querySelector('.navigation-submenu__back-bar-link');
        this.tempHolder = document.querySelector('.navigation-temp-accessibility');
        this.navPrimaryWrapper = document.querySelector('.navigation-primary--wrapper');
        this.bodyEl = document.querySelector('body');
        this.level2Headers = document.querySelectorAll('#navContainer .nav-submenu__l2-header');
        this.headerEl = document.querySelector('#progressiveHeaderSection');
        this.hamburgerNavCloseButton = document.querySelector('.navigation-burger-close');
        this.navVeil = document.querySelector('#progressiveHeaderSection > div.navigation-nav-veil');
        this.searchButtonReset = document.querySelector('.navigation-search-bar--clear');
        this.searchiconButton = document.querySelector('.navigation-search-bar--submit');
        this.searchBar = document.querySelector('.navigation-search-bar--search');
        this.searchBarSuggession = document.querySelector('.navigation-search-bar--suggestion-dropdown');
        this.navPrimaryListEl = document.querySelectorAll('.nav-primary__list li');
        this.navBottomAccountIcon = document.querySelectorAll('.navigation-bottom-myaccount>a>i.navigation-primary__menu-icon.navigation-icon--my-account');
        this.navBottomMyAccount = document.querySelectorAll('.navigation-bottom-myaccount');
        this.navBottomSparksIcon = document.querySelectorAll('.navigation-bottom-sparks');
        this.navBottomFindStore = document.querySelectorAll('.navigation-bottom--find-store');
        this.navBottomFindStoreIcon = document.querySelectorAll('.navigation-bottom--find-store>a>i.navigation-mobile-location-finder');
        this.navPrimaryList = document.querySelectorAll('.nav-primary__list');
        this.navBottomContainerOne = document.querySelector('.navigation-pane-one-navbottom');
        this.navPrimaryFixedTopBar = document.querySelector('.navigation-burger__fixedtopmenu');
        this.goToCountryLink = document.querySelector('.navigation-country-mobile--link');
        this.mobileNavLogo = document.querySelector('.navigation-burger__fixedtopmenu .navigation-logo');
        this.headerEL = document.getElementById('common-hdr-main');
        this.countrySelectorHead = document.querySelector('.navigation-mobile-country-header');
        this.countrySelector = document.querySelector('.navigation-mobile-country-selector');
        this.mobileCountryDiv = document.querySelector('.navigation-nav-country-selector');
        this.mobileCountryDropdown = document.querySelector('.navigation-country-mobile--country-list');
        this.mobileLanguageDropdown = document.querySelector('.navigation-country-mobile--language-list');
        this.bannerImageSection = document.querySelector('.navigation-banner-responsive');
        this.spinnerImageSection = document.querySelector('.navigation-bannerspinner');
        this.userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        this.navBottomContainerLinks = document.querySelectorAll('.navigation-bottom-container a');
        this.navPrimaryListLinks = this.navPrimaryList[0].querySelectorAll('a');
        // bind functions for event listeners
        this.level2Click = this.level2Click.bind(this);
        this.toggleCountrySelectorDiv = this.toggleCountrySelectorDiv.bind(this);
        this.searchButtonResetClick = this.searchButtonResetClick.bind(this);
        this.mobileMenuToggle = this.mobileMenuToggle.bind(this);
        this.backClick = this.backClick.bind(this);
        this.toggleLevel3 = this.toggleLevel3.bind(this);
        this.toggleLevel3Keyup = this.toggleLevel3Keyup.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.checkHeaderClickToClose = this.checkHeaderClickToClose.bind(this);
        this.myAccount = this.myAccount.bind(this);
        this.loopFocus = this.loopFocus.bind(this);
        this.loadseasonalBanner = this.loadseasonalBanner.bind(this);
        this.interactionEvent = 'click';
        this.goToCountryLinkClick = this.goToCountryLinkClick.bind(this);
        this.mnsHeaderConfig = window.mnsHeaderConfig;
        if (util.hasTouchCapability()) {
            this.interactionEvent = TOUCH_START;
        }
    }

    XSmallDevice.prototype.searchButtonResetClick = function () {
        domQ(this.searchBarSuggession).addClass('navigation-search-bar--suggestion-dropdown__hidden');
        this.searchBar.value = '';
    };
    XSmallDevice.prototype.errorPromptPopupClick = function (e) {
        e.preventDefault();
    };
    XSmallDevice.prototype.analytics = function () {
        var analyticActions = [{
            functionName: 'analyticsL1Nav',
            event: 'click'
        }];
        analytics.bind(this.navPrimaryListEl, analyticActions);
    };
    XSmallDevice.prototype.bind = function () {
        var _this = this;
        var thematicflag = false;
        for (var iCount = 0; iCount < this.level2.navPrimaryAList.length; iCount++) {
            var link = this.level2.navPrimaryAList[iCount];
            link.addEventListener(_this.interactionEvent, _this.level2Click);
            if (_this.interactionEvent === TOUCH_START) {
                link.removeEventListener('touchstart', _this.level2Click);
                link.addEventListener('click', _this.level2Click);
            }
        }

        for (var navPrimaryListElCount = 0; navPrimaryListElCount < this.navPrimaryListEl.length; navPrimaryListElCount++) {
            var navLiEl = this.navPrimaryListEl[navPrimaryListElCount];
            if (!domQ(navLiEl).hasClass('nav-primary-inspire-me')) {
                navLiEl.addEventListener(_this.interactionEvent, _this.level2Click);
                if (_this.interactionEvent === TOUCH_START) {
                    navLiEl.removeEventListener('touchstart', _this.level2Click);
                    navLiEl.addEventListener('click', _this.level2Click);
                }
            }
            if (navLiEl.innerText.indexOf('Bank') !== -1 && domQ(navLiEl.previousElementSibling).hasClass('nav-primary-inspire-me')) {
                navLiEl.style.borderBottom = 'none';
                thematicflag = true;
                domQ(navLiEl).addClass('navigation-bankClass');
            }
        }

        if (!thematicflag) {
            if (document.querySelector('.nav-primary-inspire-me')) {
                document.querySelector('.nav-primary-inspire-me').style.borderBottom = 'none';
            }
        }

        this.hamburgerEl.addEventListener('click', this.mobileMenuToggle);
        this.backButtonEl.addEventListener('click', this.backClick);
        this.searchButtonReset.addEventListener('click', this.searchButtonResetClick);
        for (var iHeader = 0; iHeader < this.level2Headers.length; iHeader++) {
            var header = this.level2Headers[iHeader];
            header.addEventListener('click', _this.toggleLevel3);
        }
        this.navigationOverlayEl.addEventListener(this.interactionEvent, this.closeMenu);
        this.goToCountryLink.addEventListener(this.interactionEvent, this.goToCountryLinkClick);
        //close the hamburger on click event only
        this.navVeil.addEventListener('click', this.checkHeaderClickToClose);
        this.countrySelectorHead.addEventListener('click', this.toggleCountrySelectorDiv);
        this.hamburgerNavCloseButton.addEventListener('click', this.checkHeaderClickToClose);
        document.querySelector('.navigation-primary--wrapper').tabIndex = '0';
        this.setup();
        //for safari-bfcache clear
        window.onpageshow = function (event) {
            if (event.persisted) { //from bf cache
                window.location.reload();
            }
        };
        this.setPrimarySection();
        this.analytics();
        var analyticActionsL2Open = [{
            functionName: 'analyticsL2OpenNav',
            event: 'click'
        }];
        analytics.bind(this.level2Headers, analyticActionsL2Open);
        this.menuLastItem.addEventListener('focus',function(){
            var menuCloseIcon= document.querySelector('.navigation-burger-close');
            menuCloseIcon.focus();
        });
        this.tempHolder.addEventListener('focus', this.loopFocus);
        this.tempHolder.addEventListener('click', this.loopFocus);
    };
    XSmallDevice.prototype.unbind = function () {
        var _this = this;
        for (var iCount = 0; iCount < this.level2.navPrimaryAList.length; iCount++) {
            var link = this.level2.navPrimaryAList[iCount];
            link.removeEventListener(_this.interactionEvent, _this.level2Click);
            if (_this.interactionEvent === TOUCH_START) {
                link.removeEventListener('click', util.preventClick);
            }
        }
        for (var navPrimaryListElCount = 0; navPrimaryListElCount < this.navPrimaryListEl.length; navPrimaryListElCount++) {
            var navLiEl = this.navPrimaryListEl[navPrimaryListElCount];
            if (!domQ(navLiEl).hasClass('nav-primary-inspire-me')) {
                navLiEl.removeEventListener(_this.interactionEvent, _this.level2Click);
                if (_this.interactionEvent === TOUCH_START) {
                    navLiEl.removeEventListener('click', _this.level2Click);
                }
            }

            if (domQ(navLiEl).hasClass('navigation-bankClass')) {
                domQ(navLiEl).removeClass('navigation-bankClass');
            }
        }
        this.hamburgerEl.removeEventListener('click', this.mobileMenuToggle);
        this.backButtonEl.removeEventListener('click', this.backClick);
        for (var iHeader = 0; iHeader < this.level2Headers.length; iHeader++) {
            var header = this.level2Headers[iHeader];
            header.removeEventListener('click', _this.toggleLevel3);
        }
        this.navigationOverlayEl.removeEventListener(this.interactionEvent, this.closeMenu);
        this.navVeil.removeEventListener('click', this.checkHeaderClickToClose);
        document.querySelector('.navigation-primary--wrapper').removeAttribute('tabIndex');
        this.hamburgerNavCloseButton.removeEventListener('click', this.checkHeaderClickToClose);
        this.teardown();
        this.tempHolder.removeEventListener('focus', this.loopFocus);
        this.tempHolder.removeEventListener('click', this.loopFocus);
    };
    XSmallDevice.prototype.toggleCountrySelectorDiv = function () {
        countryLinkDropDown.buildDropDown();
        countryLinkDropDown.resetDropDown();
        if (domQ(this.countrySelector).hasClass('navigation-country-overlay-visible')) {
            domQ(this.countrySelector).removeClass('navigation-country-overlay-visible');
            setTimeout(function () {
                document.querySelector('.navigation-mobile-country-selector').style.display = 'none';
            }, 500);
        }
        else {
            this.navPrimarySectionEl.style.overflowY = 'hidden';
            var parentEl = this.navPrimarySectionEl;
            var countryDiv = this.mobileCountryDiv;
            this.countrySelector.style.display = 'block';
            setTimeout(function () {
                domQ(document.querySelector('.navigation-mobile-country-selector')).addClass('navigation-country-overlay-visible');
            }, 50);
            setTimeout(function () {
                parentEl.scrollTop = countryDiv.offsetTop;
                parentEl.style.overflowY = 'scroll';
            }, 500);
        }
        if (domQ(this.countrySelectorHead).hasClass('navigation-country-toggle-arrow')) {
            domQ(this.countrySelectorHead).removeClass('navigation-country-toggle-arrow');
            this.countrySelectorHead.setAttribute('aria-expanded', 'false');
            countryLinkDropDown.resetDropDown();
        }
        else {
            domQ(this.countrySelectorHead).addClass('navigation-country-toggle-arrow');
            this.countrySelectorHead.setAttribute('aria-expanded', 'true');
        }
    };
    XSmallDevice.prototype.goToCountryLinkClick = function () {
        if (this.goToCountryLink.href === 'javascript:;') {
            this.closeMenu();
        }
    };
    XSmallDevice.prototype.setup = function () {
        var _this = this;
        this.myAccount();
        if (this.navContainerEl.classList.contains(IS_ACTIVE)) { //close menu only if it is open
            this.backClick();
        }
        clearTimeout(this.setTimeoutId);
        this.setTimeoutId = setTimeout(function () {
            _this.addAnimation();
        }, 100);
    };
    XSmallDevice.prototype.teardown = function () {
        this.level2.deactivate();
        this.removeAnimation();
        this.closeMenu();
    };
    XSmallDevice.prototype.addAnimation = function () {
        this.navPrimarySectionEl.style.transition = ANIMATION_TRANSITION;
        this.navPrimaryFixedTopBar.style.transition = ANIMATION_TRANSITION;
    };
    XSmallDevice.prototype.removeAnimation = function () {
        this.navPrimarySectionEl.style.transition = 'none';
        this.navPrimaryFixedTopBar.style.transition = 'none';
    };
    XSmallDevice.prototype.myAccount = function () {
        var isAuthenticated = this.level2.auth.isAuthenticated();
        var mobileAccountEl = document.querySelector('.navigation-bottom-container');
        this.displayNode(mobileAccountEl.children[1].children[0].children[2], isAuthenticated);
        this.displayNode(mobileAccountEl.children[1].children[0].children[3], !isAuthenticated);
    };
    XSmallDevice.prototype.displayNode = function (el, show) {
        el.style.display = show ? 'block' : 'none';
    };
    XSmallDevice.prototype.level2Open = function (el) {
        this.isActiveBottomContainer();
        this.backButtonEl.style.display = 'inline-block';
        //If Span is replaced with <img> in future change the below code
        if (el.tagName === 'DIV' && el.parentElement && !el.parentElement.classList.contains(IS_ACTIVE)) {
            this.level2.activate(el.parentElement);
            this.setBackLabel(el.parentElement.innerHTML, el.parentElement.pathname);
        } else if (el.tagName === 'IMG' && el.parentElement.parentElement && !el.parentElement.parentElement.classList.contains(IS_ACTIVE)) {
            this.level2.activate(el.parentElement.parentElement);
            this.setBackLabel(el.parentElement.parentElement.innerHTML, el.parentElement.parentElement.pathname);
        } else if (el.tagName === 'IMG' && el.parentElement.parentElement) {
            this.setBackLabel(el.parentElement.parentElement.innerHTML, el.parentElement.parentElement.pathname);
        } else if (el.tagName === 'LI' && el.firstElementChild && !el.firstElementChild.classList.contains(IS_ACTIVE)) {
            this.level2.activate(el.firstElementChild);
            this.setBackLabel(el.firstElementChild.innerHTML, el.firstElementChild.pathname);
        } else {
            if (!domQ(el).hasClass(IS_ACTIVE)) {
                this.level2.activate(el);
                this.setBackLabel(el.innerHTML, el.pathname);
            }
        }

        var subMenuID = el.getAttribute('data-cmspot-id');
        var subMenu = document.getElementById(subMenuID);
        if(subMenu) {
            subMenu.tabIndex = '0';
        }

        this.navContainerEl.setAttribute('aria-hidden','false');
        this.menuLastItem.tabIndex= -1;
        this.navPrimarySectionEl.tabIndex = -1;
        this.navPrimarySectionEl.setAttribute('aria-hidden', true);
        this.navPrimaryList[0].tabIndex = -1;
        this.navPrimaryList[0].setAttribute('aria-hidden', true);
        this.countrySelectorHead.tabIndex = -1;
        this.countrySelectorHead.setAttribute('aria-hidden', true);
        this.mobileCountryDropdown.tabIndex = -1;
        this.mobileCountryDropdown.setAttribute('aria-hidden', true);
        this.mobileLanguageDropdown.tabIndex = -1;
        this.mobileLanguageDropdown.setAttribute('aria-hidden', true);
        this.goToCountryLink.tabIndex = -1;
        this.goToCountryLink.setAttribute('aria-hidden', true);

        for(var navL1i=0; navL1i<this.navPrimaryListLinks.length; navL1i++) {
            this.navPrimaryListLinks[navL1i].tabIndex = -1;
            this.navPrimaryListLinks[navL1i].setAttribute('aria-hidden', 'true');
        }
        for(var navBotmI=0; navBotmI<this.navBottomContainerLinks.length; navBotmI++) {
            this.navBottomContainerLinks[navBotmI].tabIndex = -1;
            this.navBottomContainerLinks[navBotmI].setAttribute('aria-hidden', 'true');
        }

        var headers = document.querySelectorAll('.navigation-open-submenu .nav-submenu__span--four-fifths .nav-submenu__l2-header');
        util.setTabIndex(headers, '0');
        this.backButtonEl.tabIndex = 0;
        this.backButtonEl.focus();
        if (this.tempHolder) {
            this.displayNode(this.tempHolder, true);
        }
    };
    XSmallDevice.prototype.isActiveBottomContainer = function () {
        if (this.navBottomContainerOne && domQ(this.navBottomContainerOne).hasClass(IS_ACTIVE)) {
            domQ(this.navBottomContainerOne).removeClass(IS_ACTIVE);
        }
    };
    XSmallDevice.prototype.level2Click = function (e) {
        e.preventDefault();
        this.level2Open(e.target);
        return false;
    };
    XSmallDevice.prototype.mobileMenuToggle = function () {
        if (this.navPrimarySectionEl.classList.contains(IS_ACTIVE)) {
            this.closeMenu();
        } else {
            this.openMenu();
            this.loadseasonalBanner();
        }
    };
    XSmallDevice.prototype.openMenu = function () {
        domQ(this.navPrimaryWrapper).addClass(IS_ACTIVE);
        if (domQ(this.headerEL).hasClass(STICKY_CLASS)) {
            domQ(this.bodyEl).addClass(PREVENT_STICKYSCROLLING);
            domQ(document.querySelector('html')).addClass(PREVENT_STICKYSCROLLING);
        } else {
            domQ(this.bodyEl).addClass(PREVENT_SCROLLING);
        }
        setTimeout(function () {
            document.querySelector('.navigation-primary__section').classList.add(IS_ACTIVE);
            document.querySelector('.navigation-burger__fixedtopmenu').classList.add(IS_ACTIVE);
            document.querySelector('.navigation-pane-one-navbottom').classList.add(IS_ACTIVE);
        }, 5);
        domQ(this.hamburgerEl).addClass(IS_SELECTED);
        domQ(this.navVeil).addClass(IS_ACTIVE);
        this.mobileNavLogo.style.transform = 'none';
        this.addAnimation();
        this.anchoredNavigation();
        document.querySelector('.navigation-burger__fixedtopmenu .navigation-mns-logo').focus();

        if (this.navPrimarySectionEl.classList.contains('navigation-is-level2-active')) {
            this.navPrimarySectionEl.tabIndex = -1;
            this.navPrimarySectionEl.setAttribute('aria-hidden', true);
            this.navPrimaryList[0].tabIndex = -1;
            this.navPrimaryList[0].setAttribute('aria-hidden', true);
            this.countrySelectorHead.tabIndex = -1;
            this.countrySelectorHead.setAttribute('aria-hidden', true);
            this.mobileCountryDropdown.tabIndex = -1;
            this.mobileCountryDropdown.setAttribute('aria-hidden', true);
            this.mobileLanguageDropdown.tabIndex = -1;
            this.mobileLanguageDropdown.setAttribute('aria-hidden', true);
            this.goToCountryLink.tabIndex = -1;
            this.goToCountryLink.setAttribute('aria-hidden', true);
            for(var navL1i=0; navL1i<this.navPrimaryListLinks.length; navL1i++) {
                this.navPrimaryListLinks[navL1i].tabIndex = -1;
                this.navPrimaryListLinks[navL1i].setAttribute('aria-hidden', 'true');
            }
            for(var navBotmI=0; navBotmI<this.navBottomContainerLinks.length; navBotmI++) {
                this.navBottomContainerLinks[navBotmI].tabIndex = -1;
                this.navBottomContainerLinks[navBotmI].setAttribute('aria-hidden', 'true');
            }
        } else {
            this.navPrimarySectionEl.tabIndex = 0;
            this.navPrimarySectionEl.setAttribute('aria-hidden', false);
            this.navPrimaryList[0].tabIndex = 0;
            this.navPrimaryList[0].setAttribute('aria-hidden', false);
            this.countrySelectorHead.tabIndex = 0;
            this.countrySelectorHead.setAttribute('aria-hidden', false);
            this.mobileCountryDropdown.tabIndex = 0;
            this.mobileCountryDropdown.setAttribute('aria-hidden', false);
            this.mobileLanguageDropdown.tabIndex = 0;
            this.mobileLanguageDropdown.setAttribute('aria-hidden', false);
            this.goToCountryLink.tabIndex = 0;
            this.goToCountryLink.setAttribute('aria-hidden', false);
            for(var navl1I=0; navl1I<this.navPrimaryListLinks.length; navl1I++) {
                this.navPrimaryListLinks[navl1I].removeAttribute('tabIndex');
                this.navPrimaryListLinks[navl1I].removeAttribute('aria-hidden');
            }
            for(var navBotmi=0; navBotmi<this.navBottomContainerLinks.length; navBotmi++) {
                this.navBottomContainerLinks[navBotmi].removeAttribute('tabIndex');
                this.navBottomContainerLinks[navBotmi].removeAttribute('aria-hidden');
            }
        }
    };
    XSmallDevice.prototype.closeMenu = function () {
        util.removeClass(this.bodyEl, PREVENT_STICKYSCROLLING);
        util.removeClass(document.querySelector('html'), PREVENT_STICKYSCROLLING);
        util.removeClass(this.bodyEl, PREVENT_SCROLLING);
        this.backClick();
        domQ(this.navPrimarySectionEl).removeClass(IS_ACTIVE);
        domQ(this.navPrimaryFixedTopBar).removeClass(IS_ACTIVE);
        domQ(this.navBottomContainerOne).removeClass(IS_ACTIVE);
        domQ(this.hamburgerEl).removeClass(IS_SELECTED);
        domQ(this.navVeil).removeClass(IS_ACTIVE);
        if (domQ(this.countrySelectorHead).hasClass('navigation-country-toggle-arrow')) {
            this.toggleCountrySelectorDiv();
        }
        this.navBottomContainerOne.style.transition = null;
        this.mobileNavLogo.style.transform = 'translate3d(-105%, 0, 0)';
        setTimeout(function () {
            document.querySelector('.navigation-primary--wrapper').classList.remove('navigation-is-active');
        }, 500);
        document.querySelector('.navigation-hamburger-trigger').focus();
    };
    XSmallDevice.prototype.toggleLevel3 = function (e) {
        if (e.target.classList.contains(IS_SELECTED)) {
            this.closeLevel3(e.target);
        } else {
            this.openLevel3(e.target);
        }
    };
    XSmallDevice.prototype.toggleLevel3Keyup = function (event) {
        var keyPressed = event.key || event.keyCode;
        if (keyPressed === 13 || keyPressed === 'Enter') {
            if (event.target.classList.contains(IS_SELECTED)) {
                this.closeLevel3(event.target);
            } else {
                this.openLevel3(event.target);
            }
        }
    };
    XSmallDevice.prototype.openLevel3 = function (header) {
        this.lastLevel3Header = header;
        domQ(header).addClass(IS_SELECTED);
        domQ(header.nextElementSibling).addClass('nav-submenu__selectedlink-list');
        header.nextElementSibling.style.display = 'block';
        setTimeout(function () {
            header.nextElementSibling.style.maxHeight = L3_MAXHEIGHT;
        }, 50);
        let rootEl = header.parentElement.parentElement.parentElement;
        if (header.classList.contains(IS_SELECTED)) {
            if (header.parentElement.children.length === 2) {
                header.offsetTop === 0 ? rootEl.scrollTop = header.offsetTop : rootEl.scrollTop = header.parentElement.offsetTop;
            } else {
                if (header === header.parentElement.children[0]) {
                    rootEl.scrollTop = header.parentElement.offsetTop;
                } else {
                    rootEl.scrollTop = header.offsetTop;
                }
            }
        }
    };

    XSmallDevice.prototype.closeLevel3 = function (header) {
        header.nextElementSibling.style.maxHeight = null;
        domQ(header.nextElementSibling).removeClass('nav-submenu__selectedlink-list');
        setTimeout(function () {
            header.nextElementSibling.style.display = 'none';
            domQ(header).removeClass(IS_SELECTED);
        }, 500);
    };
    XSmallDevice.prototype.closeAllLevel3 = function (iHeader) {
        var iHeaderlength = iHeader.length;
        for (var i = 0; i < iHeaderlength; i++) {
            domQ(iHeader[i]).removeClass(IS_SELECTED);
            iHeader[i].nextElementSibling.style.maxHeight = null;
            domQ(iHeader[i].nextElementSibling).removeClass('nav-submenu__selectedlink-list');
        }
    };
    XSmallDevice.prototype.setBackLabel = function (label, url) {
        this.backLabelEl.innerHTML = '<a  class="icon--hdr-arrow-right" href="' + url + '" aria-label="go to ' + label + '" >' + label + '</a>';
    };
    XSmallDevice.prototype.backClick = function () {
        var iHeader = document.querySelectorAll('#navContainer .nav-submenu__l2-header.is-selected');
        if (document.querySelector('.nav-primary__menu-link.navigation-is-active')) {
            document.querySelector('.nav-primary__menu-link.navigation-is-active').focus();
        }
        domQ(this.navContainerEl).removeClass(IS_ACTIVE);
        this.navContainerEl.setAttribute('aria-hidden','true');
        if (this.navPrimarySectionEl.classList.contains('navigation-is-level2-active')) {
            this.navPrimarySectionEl.style.transition = L1_ANIMATION_TRANSITION;
            this.navBottomContainerOne.style.transition = L1_ANIMATION_TRANSITION;
            this.navPrimarySectionEl.classList.remove('navigation-is-level2-active');
            this.navBottomContainerOne.classList.remove('navigation-is-level2-active');
            this.level2.deactivateAllMenus();
            if (iHeader && iHeader.length > 0) {
                this.closeAllLevel3(iHeader);
            }
        }
        if (!domQ(this.navBottomContainerOne).hasClass(IS_ACTIVE) && this.navPrimarySectionEl.classList.contains(IS_ACTIVE)) {
            domQ(this.navBottomContainerOne).addClass(IS_ACTIVE);
        }
        this.backButtonEl.tabIndex = -1;
        this.tempHolder.removeAttribute('style');
        this.backButtonEl.removeAttribute('style');

        this.navPrimarySectionEl.tabIndex = 0;
        this.menuLastItem.tabIndex = 0;
        this.navPrimarySectionEl.setAttribute('aria-hidden', false);
        this.navPrimaryList[0].tabIndex = 0;
        this.navPrimaryList[0].setAttribute('aria-hidden', false);
        this.countrySelectorHead.tabIndex = 0;
        this.countrySelectorHead.setAttribute('aria-hidden', false);
        this.mobileCountryDropdown.tabIndex = 0;
        this.mobileCountryDropdown.setAttribute('aria-hidden', false);
        this.mobileLanguageDropdown.tabIndex = 0;
        this.mobileLanguageDropdown.setAttribute('aria-hidden', false);
        this.goToCountryLink.tabIndex = 0;
        this.goToCountryLink.setAttribute('aria-hidden', false);

        for(var navL1I=0; navL1I<this.navPrimaryListLinks.length; navL1I++) {
            this.navPrimaryListLinks[navL1I].removeAttribute('tabIndex');
            this.navPrimaryListLinks[navL1I].removeAttribute('aria-hidden');
        }
        for(var navBotmI=0; navBotmI<this.navBottomContainerLinks.length; navBotmI++) {
            this.navBottomContainerLinks[navBotmI].removeAttribute('tabIndex');
            this.navBottomContainerLinks[navBotmI].removeAttribute('aria-hidden');
        }
    };
    XSmallDevice.prototype.checkHeaderClickToClose = function (e) {
        var target = e.target;
        var isChildOfHamburgerTrigger = this.hamburgerEl.contains(target);
        if (!(target.classList.contains(HAMBURGER_CLASS) ||
            isChildOfHamburgerTrigger)) {
            this.closeMenu();
        }
    };
    //anchored navigation
    XSmallDevice.prototype.anchoredNavigation = function () {
        var l1Menu = this.navPrimarySectionEl.querySelector('.navigation-is-active-anchor');
        var pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : 'OTH';
        var l3Menu = null,
            l3Url = window.location.pathname;
        var headerElm = document.querySelector('#common-hdr-main');
        var l3 = this.headerEL.querySelector('.navigation-anchor');
        if (l3) {
            l3.classList.remove('navigation-anchor');
        }
        if (l1Menu !== null && pageType !== 'SLP') {
            this.level2Open(l1Menu);
            if (domQ(headerElm).hasClass('navigation-sticky')) {
                var headers = document.querySelectorAll('.navigation-open-submenu .nav-submenu__span--four-fifths .nav-submenu__l2-header');
                util.setTabIndex(headers, '0');
                stickyHeader.init();
                stickyHeader.bindAnchor();
                document.querySelector('.navigation-submenu__back-bar-label a').focus();
                window.stickyActiveL1 = l1Menu;
            }
        }
        if (window.hpl3Url && window.hpl3Url !== null) {
            l3Menu = this.headerEL.querySelector('a[href$="' + window.hpl3Url + '"]');
        } else if ((window.pdpData || window.navAnchorPdpData) && l1Menu !== null) {
            var length = window.pdpData ? window.pdpData.breadcrumb.length : window.navAnchorPdpData.breadcrumb.length;
            for (var category = 2; category < length; category++) {
                l3Url = window.pdpData ? window.pdpData.breadcrumb[category].categoryUrl : window.navAnchorPdpData.breadcrumb[category].pathname;
                if (l3Menu === null) {
                    var urlWithQ = this.headerEL.querySelector('a[href^="' + l3Url + '?"]');
                    var urlWithHash = urlWithQ === null ? this.headerEL.querySelector('a[href$="' + l3Url + '#intid"]') :
                        urlWithQ;
                    l3Menu = urlWithHash === null ? this.headerEL.querySelector('a[href$="' + l3Url + '"]') :
                        urlWithHash;
                }
                if (l3Menu !== null && l3Menu.classList.length !== 0) {
                    l3Menu = null;
                }
            }
        } else if (l3Url.indexOf('/l/') !== -1) {
            var urlWithOutAnalytics = this.headerEL.querySelector('a[href$="' + l3Url + '"]');
            urlWithOutAnalytics = urlWithOutAnalytics === null ? this.headerEL.querySelector('a[href^="' + l3Url + '?"]') : urlWithOutAnalytics;
            l3Menu = urlWithOutAnalytics === null ? this.headerEL.querySelector('a[href^="' + l3Url + '#intid"]') : urlWithOutAnalytics;
            if (l3Menu === null && l3Url.indexOf('-n-') !== -1) {
                l3Url = l3Url.split('-n-')[0];
                l3Menu = this.headerEL.querySelector('a[href$="' + l3Url + '"]');
            }
        }
        if (l3Menu !== null) {
            var header = l3Menu.parentElement.parentElement.previousElementSibling;
            var rootEl = header.parentElement.parentElement.parentElement;
            header.nextElementSibling.style.transition = 'none';
            this.openLevel3(header);
            domQ(l3Menu).addClass('navigation-anchor');
            setTimeout(function () {
                rootEl.scrollTop = l3Menu.parentElement.offsetTop;
                header.nextElementSibling.style.transition = 'max-height .5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s';
            }, 30);
        }
    };

    XSmallDevice.prototype.setPrimarySection = function () {
        if (this.navPrimarySectionEl && this.navContainerEl) {
            var paneOneEl = document.querySelector('.navigation-pane-one-navbottom');
            if ((window.innerWidth === 768 || window.innerWidth === 767)) {
                this.navPrimarySectionEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 270 + 'px';
                this.navPrimaryFixedTopBar.style.width = (window.innerWidth * PRIMARY_SECTION_WIDTH) - 290 + 'px';
                this.navContainerEl.style.width = (window.innerWidth * PRIMARY_SECTION_WIDTH) - 290 + 'px';
                paneOneEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH - 270 + 'px';
            } else {
                this.navPrimarySectionEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH + 'px';
                this.navPrimaryFixedTopBar.style.width = (window.innerWidth * PRIMARY_SECTION_WIDTH) - 20 + 'px';
                this.navContainerEl.style.width = (window.innerWidth * PRIMARY_SECTION_WIDTH) - 20 + 'px';
                paneOneEl.style.width = window.innerWidth * PRIMARY_SECTION_WIDTH + 'px';
            }

        }
    };
    XSmallDevice.prototype.loopFocus = function () {
        this.backButtonEl.focus();
    };

    XSmallDevice.prototype.loadseasonalBanner = function () {
        this.bannerimageSrc = this.bannerImageSection ? this.bannerImageSection.getAttribute('data-src') : false;
        if (this.bannerimageSrc && (this.bannerImageSection.getAttribute('src') === '')) {
            this.bannerImageSection.src = this.bannerimageSrc;
            var _this = this;
            this.bannerImageSection.addEventListener('load', function () {
                _this.spinnerImageSection.remove();
                domQ(_this.bannerImageSection).removeClass('navigation-banner-hide');
            });
        }
    };
    return XSmallDevice;
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/navigation/XSmallDevice.js